import { ModelBase } from 'store/model-base';

import { DatasaverStatus } from 'my-account/constants';

export class Datasaver extends ModelBase {
    public static storeName: string = 'datasaver';
    public static idAttribute: string = 'lineKey';

    public lineKey: string;
    public state: DatasaverStatus;

    public isEligible: boolean;
    public isStatusOn: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.isStatusOn = data.state === DatasaverStatus.ON;
        data.isEligible = data.state === DatasaverStatus.ON || data.state === DatasaverStatus.OFF;

        return super.create<T>(data);
    }
}
